import { DBFind, DBFindOne, DBInsert, DBUpdateOne } from '@weblite/persist'

const ROOM_LAST_MESSAGE = 'roomLastMessageSync'

/**
 * Persist the need for updating last message, in case of e.g. closing
 * application before persisting update.
 */
interface RoomLastMessage {
  roomId: string
  // TODO handle by auto-cancellation & remove processing?
  /**
   * It's a number to make concurrent updates independent of each other
   */
  processing: number
}

export async function set(roomId: string) {
  const { processing } = (await DBFindOne(ROOM_LAST_MESSAGE, roomId)) || {}
  if (processing)
    await DBUpdateOne(ROOM_LAST_MESSAGE, roomId, { $inc: { processing: 1 } })
  else await DBInsert(ROOM_LAST_MESSAGE, { roomId, processing: 1 })

  return async function unset() {
    await DBUpdateOne(ROOM_LAST_MESSAGE, roomId, { $inc: { processing: -1 } })
  }
}

export async function getAll() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const rooms: RoomLastMessage[] = await DBFind(ROOM_LAST_MESSAGE)

  async function unset() {
    await Promise.all(
      rooms.map(({ roomId, processing }) =>
        DBUpdateOne(ROOM_LAST_MESSAGE, roomId, {
          $inc: { processing: -processing },
        }),
      ),
    )
  }

  const items = rooms.filter(room => room.processing).map(room => room.roomId)

  return { items, del: unset }
}
